import React from 'react'
import { searchUtils } from '../../../../utils/search.utils'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'

const SearchMenu = ({ options, updateOptions, searchType, setSearchType, columnsVisibility, setColumnsVisibility }) => {

    const [checkAll, setCheckAll] = React.useState(true)
    const allOption = {
        id: 'all',
        text: 'All',
        active: checkAll
    }

    const handleUpdateOptions = (option) => (e) => {
        const newOptions = [...options]
        const updatedItem = newOptions.find(o => o.id === option.id)
        updatedItem.active = !updatedItem.active
        if (newOptions.filter(o => o.id !== 'all').every(o => o.active === true)) {
            setCheckAll(true)
        } else {
            setCheckAll(false)

        }
        return updateOptions(newOptions)
    }

    const handleCheckAll = (e) => {
        setCheckAll(!checkAll)
        return updateOptions((prev) => {
            return prev.map(state => {
                return { ...state, active: !checkAll }
            })
        })
    }

    const handleSearchType = (type) => (e) => {
        if (searchType === type) return
        setSearchType(type)
    }

    const handleVisibilityChange = (columnId) => (e) => {
        if (!columnId) return
        if (columnsVisibility[columnId]) {
            setColumnsVisibility((prev) => {
                return { ...prev, [columnId]: false }
            })
        } else {
            setColumnsVisibility((prev) => {
                return { ...prev, [columnId]: true }
            })
        }
    }


    const sortedOptions = options.slice().sort((a, b) => a.text.length - b.text.length);

    return (
        <div className='flex p-4 flex-col flex-wrap gap-x-6 gap-y-2 items-center'>
            <div className="join items-center border-2 border-white">
                <button onClick={handleSearchType(searchUtils.SEARCH_TYPES.exact)} className={`btn join-item btn-xs h-7 w-36 ${searchType === searchUtils.SEARCH_TYPES.exact ? 'btn-primary text-white' : 'btn-primary  btn-outline border-solid'} `}>
                    Exacte
                </button>
                <button onClick={handleSearchType(searchUtils.SEARCH_TYPES.fuzzy)} className={`btn join-item btn-xs h-7 w-36  ${searchType === searchUtils.SEARCH_TYPES.fuzzy ? 'btn-primary text-white' : 'btn-primary btn-outline border-solid'} `}>
                    Approximative
                </button>

            </div>
            <div className="flex flex-col gap-x-6 flex-wrap gap-y-2 self-start">
                <label className={`hover:scale-95 badge badge-xs max-h-7 ${allOption.active ? 'badge-primary text-white ' : 'badge-primary badge-outline border-solid'} border shadow-md rounded-md px-2 label cursor-pointer flex gap-x-3 `}>
                    <span className={`label-text text-xs ${allOption.active ? 'text-white ' : ''} `}>{allOption.text}</span>
                    <input type="checkbox" className={`toggle toggle-xs ${allOption.active ? 'toggle-primary ' : 'toggle-disabled'} `} checked={allOption.active} onChange={handleCheckAll} />
                </label>
                {
                    sortedOptions.map(option => {
                        return (
                            <div key={option.id} className=' flex flex-row items-center space-x-2'>
                                <label className={`hover:scale-95 badge badge-xs  shadow-md rounded-md px-2 label cursor-pointer flex gap-x-3 ${option.active ? 'badge-primary text-white ' : 'badge-primary badge-outline border-solid'} `}>
                                    <span className={`label-text text-xs ${option.active ? 'text-white ' : ''} `}>{option.text}</span>
                                    <input type="checkbox" className={`toggle toggle-xs ${option.active ? 'toggle-primary ' : 'toggle-disabled'} `} checked={option.active} onChange={handleUpdateOptions(option)} />
                                </label>
                                {columnsVisibility[option.id] ? <EyeIcon onClick={handleVisibilityChange(option.id)} className='w-5 h-5' /> : <EyeSlashIcon onClick={handleVisibilityChange(option.id)} className='w-5 h-5' />}
                            </div>

                        )
                    })

                }
            </div>

        </div>
    )

}

export default SearchMenu
